import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myDecimalPipe',
})
export class MyDecimalPipe implements PipeTransform {
    numberFormatted: any = '';

    entirePart: string = '';
    decimalPart: string = '';

    transform(numberToFormat: any, numberOfDecimalDigits: number): string {
        this.numberFormatted = '';
        this.entirePart = '';
        this.decimalPart = '';
        let i = 0;
        let length = numberToFormat.toString().split('.')[0].length;

        if (length % 3 != 0) {
            i = length % 3;
            this.entirePart += numberToFormat.toString().split('.')[0].substring(0, i);
        }

        while (i < length) {
            if (length % 3 != 0) this.entirePart += '.';
            this.entirePart += numberToFormat
                .toString()
                .split('.')[0]
                .substring(i, i + 3);
            i += 3;
        }

        if (numberToFormat.toString().split('.').length == 2)
            this.decimalPart = numberToFormat.toString().split('.')[1].substring(0, numberOfDecimalDigits);
        else {
            for (let j = 0; j < numberOfDecimalDigits; j++) this.decimalPart += '0';
        }

        this.numberFormatted = this.entirePart + ',' + this.decimalPart;

        return this.numberFormatted.toString();
    }
}
